module.exports = __webpack_public_path__ + "img/1.6fb6304e.jpg";